(() => {
  const PRODUCT_PAGE_CLASS = 'template-product';
  const LABEL_SELECTOR = [
    '#MainContent label',
    '#MainContent legend',
    '#MainContent [class*="field-label" i]',
    '#MainContent [class*="field_label" i]',
    '#MainContent [class*="field-title" i]',
    '#MainContent [class*="field_title" i]',
    '#MainContent [class*="field-name" i]',
    '#MainContent [class*="field_name" i]',
    '#MainContent [class*="option-label" i]',
    '#MainContent [class*="option_label" i]',
    '#MainContent [class*="option-title" i]',
    '#MainContent [class*="option_title" i]',
    '#MainContent [class*="option-name" i]',
    '#MainContent [class*="option_name" i]'
  ].join(',');

  const parseRgba = (value) => {
    const match = String(value || '').match(/rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)(?:\s*[,/]\s*([\d.]+))?/i);
    return match
      ? [Number(match[1]), Number(match[2]), Number(match[3]), match[4] == null ? 1 : Number(match[4])]
      : null;
  };

  const luminance = (rgba) => {
    if (!rgba) return 255;
    return (rgba[0] * 0.2126) + (rgba[1] * 0.7152) + (rgba[2] * 0.0722);
  };

  const isDark = (value) => {
    const rgba = parseRgba(value);
    if (!rgba || rgba[3] === 0) return false;
    return luminance(rgba) < 125;
  };

  const nearestBackground = (el) => {
    let node = el;
    while (node && node.nodeType === 1) {
      const background = window.getComputedStyle(node).backgroundColor;
      const rgba = parseRgba(background);
      if (rgba && rgba[3] > 0.04) return background;
      node = node.parentElement;
    }
    return window.getComputedStyle(document.body).backgroundColor;
  };

  const forceReadableLabels = () => {
    if (!document.body || !document.body.classList.contains(PRODUCT_PAGE_CLASS)) return;

    document.querySelectorAll(LABEL_SELECTOR).forEach((el) => {
      if (el.closest('select, option, [role="combobox"], [role="listbox"], [role="option"], .easify-product-options [class*="-optionItem"]')) return;
      if (el.matches('.required, [class*="required" i]')) return;

      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 120) return;

      const computed = window.getComputedStyle(el);
      const fill = computed.webkitTextFillColor || computed.color;
      const darkText = isDark(computed.color) || isDark(fill);
      const darkBackground = isDark(nearestBackground(el));

      if (darkText && darkBackground) {
        el.style.setProperty('color', '#f3f1eb', 'important');
        el.style.setProperty('-webkit-text-fill-color', '#f3f1eb', 'important');
        el.style.setProperty('opacity', '1', 'important');
      }
    });
  };

  const run = () => window.requestAnimationFrame(forceReadableLabels);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  [100, 300, 700, 1400, 2500, 4500].forEach((delay) => {
    window.setTimeout(run, delay);
  });

  const startObserver = () => {
    if (!document.body || !document.body.classList.contains(PRODUCT_PAGE_CLASS)) return;
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
